import { useEffect } from 'react';
import { useQuery } from 'react-query';

import type { BuyVerifyResponseData } from '@/api/digital-gold/store/buyVerifyStore';
import { axios } from '@/library/axios';
import type { QueryConfig } from '@/library/react-query';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

export type VerifyType = {
  id: string;
  blockId: string;
  goldInRupees: number;
  action: string;
  weightInGrams: number;
  saleGoldRate: number;
};

export type VerifyRequestParamsType = {
  customerId: String;
  blockId: String;
  goldAmountInRupee?: Number;
  weightInGram?: Number;
  promoCodes: string | null;
  previousBuyLotId: string | null;
};

export const verifyBuy = (params: VerifyRequestParamsType) => {
  if (!params.customerId) {
    return null;
  }

  return axios<VerifyData, BaseResponse<BuyVerifyResponseData>, void>({
    url: `/dg/customers/${params.customerId}/buy-orders`,
    method: 'get',
    params: {
      blockId: params.blockId,
      goldAmountInRupee: params.goldAmountInRupee,
      weightInGram: params.weightInGram,
      promoCodes: params.promoCodes,
      previousBuyLotId: params.previousBuyLotId,
    },
    // headers,
  });
};

type QueryFnType = typeof verifyBuy;
export type UseGetVerifyPrice = {
  config?: QueryConfig<QueryFnType>;
  data: VerifyType;
};

export const useVerifyPrice = (payloadData: VerifyRequestParamsType) => {
  // { config = {},
  const obj = useQuery({
    queryKey: ['verifyPrice', payloadData],
    queryFn: () => verifyBuy(payloadData),
    enabled: false,
    useErrorBoundary: false,
    cacheTime: 0,
  });

  useEffect(() => {
    displayError(obj.error);
  }, [obj.error]);

  return obj;
};

export type VerifyData = {
  amount: Number;
  weight: Number;
  gst: Number;
  cess: Number;
  discountPercent?: Number;
  discountAmount?: Number;
  totalAmountBeforeDiscount?: Number;
  promoCodeDiscountAmount?: Number;
  totalAmountAfterPromoCodeDiscount?: Number;
  totalAmount: Number;
  roundOffAmount: Number;
  payableAmount: Number;
  buyLotId: Number;
};
